// src/hooks/useFreeProduct.ts
import { useState, useEffect } from 'react';
import { Product } from '../types';

export const useFreeProduct = (enabled = true) => {
    const [freeProduct, setFreeProduct] = useState<Product | null>(null);
    const [isLoading, setIsLoading] = useState(enabled);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        let cancelled = false;
        const fetchFreeProduct = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('/api/client-products?mode=free', {
                    cache: 'no-store',
                    headers: { Accept: 'application/json' },
                });
                if (!response.ok) throw new Error(`Free product request failed (${response.status})`);

                const payload = await response.json() as { product?: Product | null };
                if (payload.product && !cancelled) {
                    setFreeProduct(payload.product);
                }
            } catch (error) {
                console.error("Error fetching free product:", error);
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
          if ('requestIdleCallback' in window) {
            const idleId = window.requestIdleCallback(() => fetchFreeProduct(), { timeout: 3000 });
            return () => {
              cancelled = true;
              window.cancelIdleCallback(idleId);
            };
          } else {
            const timer = globalThis.setTimeout(fetchFreeProduct, 2500);
            return () => {
              cancelled = true;
              globalThis.clearTimeout(timer);
            };
          }
        }
    }, [enabled]);

    return { freeProduct, isLoading };
};
